import React from "react";

type Props = {
  /** Changing it tries the chat again, e.g. each time it's opened */
  resetKey: unknown;
  /** Told once when the chat fails: close it and say so */
  onError: (error: unknown) => void;
  children: React.ReactNode;
};

type State = { failed: boolean; resetKey: unknown };

/**
 * Keeps a crash inside Ask Noticeboard to Ask Noticeboard: the page underneath stays usable.
 * The chat isn't shown again until it's next opened.
 */
export default class AskNoticeboardBoundary extends React.Component<Props, State> {
  state: State = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromError(): Partial<State> {
    return { failed: true };
  }

  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null;
  }

  componentDidCatch(error: unknown) {
    console.error("[Ask Noticeboard] The chat crashed", error);
    this.props.onError(error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
